import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const onChangeFunc = (state, props) => async _ref => {
  let changePath = _ref.path,
    value = _ref.value,
    _ref$changeModifiers = _ref.changeModifiers,
    changeModifiers = _ref$changeModifiers === void 0 ? {} : _ref$changeModifiers;
  const contentPath = props.contentPath,
    path = props.path,
    parentContentPath = props.parentContentPath,
    onChange = props.onChange,
    _props$preActions = props.preActions,
    preActions = _props$preActions === void 0 ? [] : _props$preActions,
    _props$postActions = props.postActions,
    postActions = _props$postActions === void 0 ? [] : _props$postActions,
    _props$preEvents = props.preEvents,
    preEvents = _props$preEvents === void 0 ? [] : _props$preEvents,
    _props$postEvents = props.postEvents,
    postEvents = _props$postEvents === void 0 ? [] : _props$postEvents,
    type = props.type,
    variables = props.variables;
  const fullChangeModifiers = _objectSpread({
    postActions,
    preActions,
    postEvents,
    preEvents,
    contentPath,
    type,
    parentContentPath,
    path,
    variables
  }, changeModifiers);
  const change = {
    path: changePath,
    value,
    changeModifiers: fullChangeModifiers
  };

  // Dispatch the original change event, untouched.
  return onChange(change);
};
export default onChangeFunc;